import styled from "styled-components";

export const CompareCardMarker = styled.div`
  width: 70px;
  border-bottom: 6px ${props => props.shape} ${props => props.color};
  margin-bottom: 12px;
  margin-left: 8px;
`;
